var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[(_vm.isActive)?_c('div',{staticClass:"container__timer"},[_c('span',[_vm._v(_vm._s(_vm.timer))])]):_c('ws-icon',{staticClass:"container__icon",class:_vm.iconClasses},[_vm._v("clock")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }